<template>
  <div class="col-lg-12 pb-4">
    <div class="pt-2">
      <div class="text-center pt-5 mt-4">
        <b-button class="btn btn-sm" variant="primary" @click="openModalSearch">
          <i class="fas fa-search"></i> Search
        </b-button>
      </div>
      <div
        class="row custom-scroll"
        style="max-height: 400px; overflow: scroll; overflow-x: hidden"
      >
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <table class="table">
                <tbody>
                  <tr v-for="(o, index) in other" :key="index">
                    <td width="60%">
                      <div>
                        <img
                          :src="parseUrl(o.site_link)"
                          class="img-fluid rounded avatar-xs mr-2"
                          style="height: 20px; width: 25px"
                        />
                        {{ o.site_name }} (<a
                          :href="o.site_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ o.account }}</a
                        >)
                      </div>
                    </td>
                    <td width="30%"></td>
                    <td width="10%" class="text-right">
                      <a
                        href="javascript:;"
                        @click="deleteOtherSite(o.id_site)"
                        class="text-secondary"
                      >
                        <i class="bx bx-trash"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="ref-modal-search"
      :id="'modal-search'"
      centered
      size="xl"
      title="Media Hunter"
      title-class="font-18"
      ok-title="Tambahkan"
      @ok="addMedia"
      :cancel-title="$t('button.cancel.text')"
    >
      <div class="row">
        <div class="col-sm-4 mb-3"></div>
        <div class="col-sm-8 mb-3">
          <div class="input-group">
            <input
              ref="searchKey"
              type="text"
              class="form-control"
              :placeholder="$t('wizard.form.placeholder.search')"
              aria-describedby="search"
              v-on:keyup.enter="searchMediaSosial"
            />
            <div class="input-group-prepend">
              <button
                id="search"
                @click="searchMediaSosial"
                class="input-group-text bg-primary text-white"
              >
                <i class="bx bx-search-alt search-icon"></i>
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-if="!loading.search">
          <div v-if="dataResult != 0">
            <simplebar style="height: 40vh; max-height: 40vh" class="mt-3">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <div id="tab-username">
                      <div role="tablist">
                        <b-card
                          no-body
                          class="mb-1 shadow-none"
                          v-for="(user, indexuser) in dataResult[0]"
                          :key="indexuser"
                        >
                          <b-card-header
                            class="header-accordion-result"
                            header-tag="header"
                            role="tab"
                            v-b-toggle="'accordion' + indexuser"
                          >
                            <h6 class="m-0">
                              <a class="text-dark" href="javascript: void(0);"
                                >Result for username :
                                <strong>{{ user.username }}</strong>
                                ({{ $t("wizard.form.label.hint") }} )
                              </a>
                            </h6>
                          </b-card-header>
                          <b-collapse
                            :id="'accordion' + indexuser"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <!-- <b-card-body> -->
                            <div class="row my-2">
                              <div
                                class="col-xl-3 col-sm-4 mb-3"
                                v-for="(res, index) in user.result"
                                :key="index"
                              >
                                <div class="card border">
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="avatar-xl mr-4 col-sm-5">
                                        <img
                                          :src="parseUrl(res.link)"
                                          alt
                                          height="50"
                                        />
                                      </div>
                                      <div
                                        class="
                                          media-body
                                          overflow-hidden
                                          col-sm-7
                                        "
                                      >
                                        <h5 class="text-truncate font-size-15">
                                          <a href="#" class="text-dark">{{
                                            res.site
                                          }}</a>
                                        </h5>
                                        <p class="text-muted mb-2">
                                          @{{ user.username }}
                                        </p>
                                        <div class="mt-4 row">
                                          <div class="col-sm-6">
                                            <a
                                              :href="res.link"
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              See Profile</a
                                            >
                                          </div>
                                          <div class="col-sm-6 text-right">
                                            <div
                                              v-if="res.active != true"
                                              @click="
                                                setSelectMedsos(
                                                  res.site,
                                                  res.link,
                                                  user.username,
                                                  index,
                                                  indexuser
                                                )
                                              "
                                              class="cursor-pointer"
                                            >
                                              <i
                                                class="
                                                  fas
                                                  fa-user-plus fa-2x
                                                  text-secondary
                                                "
                                              ></i>
                                            </div>
                                            <div
                                              class="cursor-pointer"
                                              v-if="res.active"
                                            >
                                              <i
                                                class="
                                                  fas
                                                  fa-user-check fa-2x
                                                  text-success
                                                "
                                              ></i>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- </b-card-body> -->
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </simplebar>
            <simplebar style="height: 20vh; max-height: 20vh" class="mt-3">
              <div class="col-sm-12 mt-4">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Account</th>
                        <th class="text-right" width="10%">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, i) in selectedMedsos" :key="i">
                        <td>@{{ sel.username }}</td>
                        <td>{{ sel.site }}</td>
                        <td class="text-right" width="10%">
                          <b-button
                            class="btn btn-sm"
                            variant="danger"
                            @click="unsetSelectMedsos(i, sel.idx)"
                          >
                            Delete</b-button
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </simplebar>
          </div>
        </div>
        <div class="col-sm-12" v-else>
          <div class="text-center">
            <i class="bx-md bx bx-loader-circle bx-spin"></i>
            <h3>Searching ...</h3>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import Swal from "sweetalert2";
import SherlockService from "@/helpers/sherlock.service";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import TwintService from "@/helpers/twint.service";

export default {
  props: { id_target: String },
  components: { simplebar },

  data() {
    return {
      other: [],
      dataResult: [],
      selectedMedsos: [],
      id_telegram: "",
      id_twitter: "",
      id_facebook: "",
      id_tiktok: "",
      id_instagram: "",
      loading: { search: false, add: false },
    };
  },
  watch: {
    id_target: {
      immediate: true,
      handler(n, o) {
        if (n != "") {
          this.getOtherSites();
        }
      },
    },
  },
  methods: {
    openModalSearch() {
      this.$bvModal.show("modal-search");
    },
    getOtherSites() {
      const dataBody = {
        target: this.id_target,
      };
      SocmedService.getOtherSitesTarget(dataBody)
        .then((response) => {
          this.other = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$bvModal.hide("modal-search");
        });
    },
    searchMediaSosial() {
      let skey = this.$refs.searchKey;
      this.dataResult = [];
      if (skey.value !== "") {
        const data = {
          option: "--timeout 1",
          username: skey.value,
        };
        this.loading.search = true;
        SherlockService.search(data)
          .then((response) => {
            this.dataResult.push(response.data.output);
            this.loading.search = false;
          })
          .catch((err) => {
            this.loading.search = false;
          });
      } else {
        this.dataResult = "";
      }
    },
    addMedia(ev) {
      ev.preventDefault();
      for (let i = 0; i < this.selectedMedsos.length; i++) {
        console.log(
          "IS exs ",
          this.other.some(
            (item) => item.site_name == this.selectedMedsos[i].site
          )
        );
        console.log("Name ", this.selectedMedsos[i].site);
        if (
          this.other.some(
            (item) => item.site_name == this.selectedMedsos[i].site
          )
        ) {
          this.updateMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        } else {
          this.saveMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        }
      }
      this.getOtherSites();
      // this.$bvModal.hide("modal-search");
    },
    deleteOtherSite(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          SocmedService.deleteOtherSites(id)
            .then((response) => {
              this.getOtherSites();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    saveMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.createTwitter(tw)
                .then((response) => {
                  this.id_twitter = response.data.data.id_twitter;
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => {
                  this.updateMediaTarget("tw");
                });
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        SocmedService.createFacebook(fb)
          .then((response) => {
            this.id_facebook = response.data.data.id_facebook;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget("fb");
          });
      } else if (site == "Instagram") {
        const ig = { account: username };
        SocmedService.createInstagram(ig)
          .then((response) => {
            this.id_instagram = response.data.data.id_instagram;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget("ig");
          });
      } else if (site == "TikTok") {
        const tk = { account: username };
        SocmedService.createTiktok(tk)
          .then((response) => {
            this.id_tiktok = response.data.data.id_tiktok;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget("tk");
          });
      } else if (site == "Telegram") {
        const tl = { account: username };
        SocmedService.createTelegram(tl)
          .then((response) => {
            this.id_telegram = response.data.data.id_telegram;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget("tl");
          });
      } else {
        const other = {
          id_target: this.id_target,
          site_name: site,
          site_link: link,
          account: username,
        };
        SocmedService.createOtherSite(other)
          .then((response) => {})
          .catch((err) => {
            console.log(err);
          })
          .finally();
      }
    },
    updateMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.updateTwitter(this.id_twitter, tw)
                .then((response) => {})
                .catch((err) => {
                  console.log(err);
                })
                .finally();
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        SocmedService.updateFacebook(this.id_facebook, fb)
          .then((response) => {})
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else if (site == "Instagram") {
        const ig = { account: username };
        SocmedService.updateInstagran(this.id_instagram, ig)
          .then((response) => {})
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else if (site == "Tiktok") {
        const tk = { account: username };
        SocmedService.updateTiktok(this.id_tiktok, tk)
          .then((response) => {})
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else if (site == "Telegram") {
        const tl = { account: username };
        SocmedService.updateTelegram(this.id_telegram, tl)
          .then((response) => {})
          .catch((err) => {
            console.log(err);
          })
          .finally();
      } else {
        let site_act = this.other.filter((item) => {
          return item.site_name == site ? item.id_site : null;
        });
        if (site_act[0].id_site) {
          const other = {
            id_target: this.id_target,
            site_name: site,
            site_link: link,
            account: username,
          };
          SocmedService.updateOtherSite(site_act[0].id_site, other)
            .then((response) => {})
            .catch((err) => {
              console.log(err);
            })
            .finally();
        }
      }
    },
    updateMediaTarget(type) {
      const mediaId = new FormData();
      if (type == "tl") {
        mediaId.append("id_telegram", this.id_telegram);
      }
      if (type == "tw") {
        mediaId.append("id_twitter", this.id_twitter);
      }
      if (type == "fb") {
        mediaId.append("id_facebook", this.id_facebook);
      }
      if (type == "ig") {
        mediaId.append("id_instagram", this.id_instagram);
      }
      if (type == "tk") {
        mediaId.append("id_tiktok", this.id_tiktok);
      }
      TargetService.update(this.id_target, mediaId)
        .then((response) => {})
        .catch((err) => {})
        .finally(() => {
          this.getOtherSites();
        });
    },
    setSelectMedsos(site, link, username, index, indexusr) {
      const data = {
        site: site,
        link: link,
        username: username,
        idx: indexusr + "-" + index,
      };
      this.dataResult[0][indexusr].result[index].active = true;
      if (this.selectedMedsos != 0) {
        for (let i = 0; i < this.selectedMedsos.length; i++) {
          if (this.selectedMedsos[i].site == site) {
            this.selectedMedsos.splice(i, 1);
          }
        }
      }
      this.selectedMedsos.push(data);
    },
    unsetSelectMedsos(index, idx) {
      let idx_split = idx.split("-");
      this.selectedMedsos.splice(index, 1);
      this.dataResult[0][idx_split[0]].result[idx_split[1]].active = false;
    },
    parseUrl(url) {
      let loc = new URL(url);
      let url_icon = "";
      switch (loc.host) {
        case "www.capfriendly.com":
          url_icon =
            loc.protocol +
            "//" +
            loc.host +
            "/assets/images/favicons/favicon.ico";
          break;

        default:
          url_icon = loc.protocol + "//" + loc.host + "/favicon.ico";
          break;
      }
      return url_icon;
    },
  },

  beforeMount() {},
};
</script>